/* eslint-disable react-hooks/exhaustive-deps */
import {Button} from "primereact/button";
import React, {useEffect, useState} from "react";
import {Dialog} from "primereact/dialog";
import useApiOrderToCash from "../../api/operaciones/useApiOrderToCash";
import ExGrid from "../../shared/Grid/ExGrid";
import ExColumn from "../../shared/Grid/ExColumn";
import FormTextBox from "../../shared/forms/FormFields/FormTextBox";

const ActualizarIdViaje = ({viajes, datosLoad, onHide, onRegistered}) => {
     const [viajesSeleccionados, setViajesSeleccionados] =  useState([]);
    const [,setPendiente] = useState(null);
    const [,setForm] = useState({submitted:false, valid:false});
    const mostrarViajes = datosLoad != null;
    const api= useApiOrderToCash();
   
    useEffect(() => {
        if (mostrarViajes) {
            mostrarViajesSelccionados();
        } else {
            setViajesSeleccionados([]);
            setPendiente(null);
        }
    }, [mostrarViajes, viajes]);

    const mostrarViajesSelccionados = () => {
        const nuevoPendiente = viajes.length > 0 ? viajes[0].pendiente : null;
        const nuevosViajes = viajes; 
        setViajesSeleccionados(nuevosViajes);
        setPendiente(nuevoPendiente);
    };


    const registrarIdViaje = async () => {
        console.log('.')
       const viaje = viajesSeleccionados.length > 0 ? viajesSeleccionados[0] : null;
        if (viaje) {
            await api.registrarLoad(viaje);
            onRegistered();
        }

    };

    const renderFooterFacturas = () => {
        return (
            <div>
                <Button label="Registrar" icon="pi pi-check" onClick={registrarIdViaje} autoFocus/>
            </div>
        );
    };

    const onValidate = (error)=>{
        setForm({submitted: true, valid:!error});
    }

    return (
        <>
            <Dialog header="Actualizar Load" visible={mostrarViajes} style={{width: '800px'}}
                    footer={renderFooterFacturas('displayBasic')} onHide={onHide}>
                <ExGrid
                    headerClass="header-class"
                    data={viajesSeleccionados}
                    onChange={setViajesSeleccionados}
                    getEntityId={(v)=>v.viajeId}
                    style={{maxHeight:'50vh'}}
                    onValidate={(valid)=> onValidate(valid)}
                >
                    <ExColumn field={'cliente'} title={'CLIENTE'} width={'3fr'}></ExColumn>
                    <ExColumn field={'cartaPorte'} title={'CARTA PORTE'} width={'1fr'}></ExColumn>
                   
                     <ExColumn  field={'idViaje'} title={'Id Viaje'} 
                               required cellRenderer={FormTextBox} ></ExColumn>
                </ExGrid>
               
            </Dialog>
        </>
    )
}

export default ActualizarIdViaje;
